import { Form, Input, InputNumber, Radio, Select } from "antd";
import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getSignupCategory } from "../../redux/actions/accountActions";
import { RootState } from "../../redux/rootReducer";
import { Actions, SignupStatus } from "../../shared/constant";
import globalUtils from "../../utils/globalUtils";

// TODO REUSE THIS FORM FOR SIGNUP REQUEST ALSO
const SignupRequestForm = ({ mode = "" }: { mode?: string }) => {
  const dispatch = useDispatch();
  const { category } = useSelector((state: RootState) => state.account);

  useEffect(() => {
    dispatch(getSignupCategory());
  }, []);

  return (
    <div>
      <Form.Item
        name="category"
        label="Category"
        rules={[{ required: true }]}
        initialValue={category[0]?.id}
      >
        <Radio.Group>
          {category.map((type: any) => (
            <Radio key={type.id} value={type.id}>
              {type.label}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
      <div className="md:grid grid-cols-2 gap-x-6">
        <Form.Item
          name="full_name"
          label="Full Name"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="mobile_no"
          label="Phone No"
          rules={[{ required: true }]}
        >
          <Input type="number" />
        </Form.Item>
      </div>
      <Form.Item
        name="email"
        label="Email"
        rules={[{ required: true }, { type: "email" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea />
      </Form.Item>
      <div
        className={mode === Actions.EDIT ? "md:grid grid-cols-2 gap-x-6" : ""}
      >
        <Form.Item name="total_songs" label="Total Songs" initialValue={null}>
          <InputNumber className="w-full" />
        </Form.Item>
        {mode === Actions.EDIT && (
          <Form.Item name="status" label="Status" rules={[{ required: true }]}>
            <Select
              placeholder="Select"
              filterOption={(inputValue, option) =>
                option?.props.children
                  .toString()
                  .toLowerCase()
                  .includes(inputValue.toLowerCase())
              }
              showSearch
              allowClear
            >
              {Object.keys(SignupStatus).map((status) => (
                <Select.Option key={status} value={status}>
                  {globalUtils.snakeCaseToCapitalize(status)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}
      </div>
      <Form.Item name="popular_songs" label="Popular Songs">
        <Input />
      </Form.Item>
    </div>
  );
};

export default SignupRequestForm;
